import React from 'react'
import { AlertRec } from '../StdLib'

export default function Home() {

  // AlertRec(_AccRecs, 'ABOUT PAGE ******************** NEAT _AccRec in main prgb**********************')
  return (
    <>
      <div >

        <div className='w-full md:flex '>
          <div className='px-2 md:pl-20 w-full md:w-1/2'>
            <p className='text-7xl mt-10 font-poppins text-blue-900'>Welcome!</p>

            <p className='text-5xl mt-10 font-poppins text-blue-600'>Smart Business Applications</p>
            <div className='md:text-2xl mt-5 md:ml-0 '>
              <p className='mt-2 font-poppins text-black inline-flex gap-2'><span><img src="/assets/BulletPoints/BulletPoint2.png" className="h-8" alt="" /></span> Small and Medium Businesses</p>
              <p className='mt-2 font-poppins text-black inline-flex gap-2'><span><img src="/assets/BulletPoints/BulletPoint2.png" className="h-8" alt="" /></span> Traders, Distributors & Manufactures</p>
              <p className='mt-2 font-poppins text-black inline-flex gap-2'><span><img src="/assets/BulletPoints/BulletPoint2.png" className="h-8" alt="" /></span> Diagnostics and Clinical Services</p>
              <p className='mt-2 font-poppins text-black inline-flex gap-2'><span><img src="/assets/BulletPoints/BulletPoint2.png" className="h-8" alt="" /></span> Pharmacies with Consultancy Services</p>
            </div>
          </div>

          <div className='mx-auto w-full md:w-1/2 p-10 '>
            <div className='mx-auto w-full  rounded-xl shadow-xl overflow-hidden'>
              <img className='w-full h-full object-fill' src={'/Images/UnderConstruction/webpage-UC.png'} alt={''} />
            </div>
          </div>


        </div>
      </div>

    </>
  )
}
